import { Product } from 'types/product';
import { ColorInput, ColorLabel, StyledProductColor } from './styles';

interface Props {
  item: Product,
}

export function ProductColor({ item }: Props) {
  return (
    <StyledProductColor>
      {item.colors.map((color, index) => {
        const colorProduct = color.toLowerCase();
        return (
          <div key={index}>
            <ColorInput
              type="radio"
              name={`select-color--product${item.id}`}
              id={`color-${colorProduct}${item.id}`}
            />
            <ColorLabel
              htmlFor={`color-${colorProduct}${item.id}`}
              style={{ backgroundColor: colorProduct, width: '20px', height: '20px' }}
            >
            </ColorLabel>
          </div>
        );
      })}
    </StyledProductColor>
  );
}
